module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAzUExURUdwTK2traysrK2traysrK2tra+vr6ysrK+vr62traysrK+vr62traurq62traqqqq2trXTY06MAAAAQdFJOUwCf0MBgRRDwMHrgH49fsA9YTyOmAAAAmElEQVQY022QWRLEIAhEcWFxifH+p03ETBHN+AHlk+6iBQCoPRT4HOfRsey0erqfMq1UmKZk5cnNHtKKn6tb8RG0RT4XXDop3Vfx8es8XLIW2nnGoal/xwvHnauxTF4SWlDUmkYJJjt0PckBbybGk34M1R7NTqO/4wgX80HjzcIht1+i8h452+NJWzT0XFHQuz0YutzH+nABd6UD9oaPm1kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/telicon.png
// module id = 1800
// module chunks = 5